import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/HorizontalNavigation/HorizontalNavigation.js'
import WebComponent from '../../WebComponent.js'
import Navigation from './Navigation.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'

export default class HorizontalNavigation extends WebComponent {

  get translationFile() {
    return './views/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => {
      this.reload()
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
    this.render()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {
    const authorizationFilter = new AuthorizationFilter()
    const items = [
      {
        text: this.i18n.translate('navigation.start'),
        url: Navigation.ROUTES.dashboard.url,
        suburls: [
          Navigation.ROUTES.onboarding.url,
          Navigation.ROUTES.gpVerfuegungSetup.url,
          Navigation.ROUTES.verfuegungNeu.url,
          Navigation.ROUTES.verfuegungPendent.url,
          Navigation.ROUTES.vnbDashboardOffeneEinladungen.url,
        ],
        active: true
      },
      {
        text: this.i18n.translate('navigation.gp'),
        url: authorizationFilter.roles.GP ? Navigation.ROUTES.gpStammdaten.url : Navigation.ROUTES.geschaeftspartner.url,
        suburls: [Navigation.ROUTES.gpStammdaten.url, Navigation.ROUTES.gpVerbrauchsstaette.url, Navigation.ROUTES.gpBenutzer.url, Navigation.ROUTES.gpZVV.url, Navigation.ROUTES.gpImport.url]
      },
      {
        text: this.i18n.translate('navigation.zvv'),
        url: Navigation.ROUTES.zvvStammdaten.url,
        suburls: [Navigation.ROUTES.zvvMitglieder.url]
      },
      {
        text: this.i18n.translate('navigation.vnb'),
        url: authorizationFilter.roles.VNB ? Navigation.ROUTES.vnbStammdaten.url : Navigation.ROUTES.verteilnetzbetreiber.url,
        suburls: [Navigation.ROUTES.vnbStammdaten.url, Navigation.ROUTES.vnbBenutzer.url, Navigation.ROUTES.vnbImport.url]
      },
      {
        text: this.i18n.translate('navigation.kontingentierung'),
        url: Navigation.ROUTES.monitoringVerordnung.url,
        suburls: [
          Navigation.ROUTES.monitoringVerbrauch.url,
          Navigation.ROUTES.monitoringKontingent.url,
          Navigation.ROUTES.kontingentWeitergabe.url,
          Navigation.ROUTES.monitoringPeriodeVnb.url
        ]
      },
      {
        text: this.i18n.translate('navigation.verordnung'),
        url: Navigation.ROUTES.verordnung.url,
        suburls: [Navigation.ROUTES.verordnungCreate.url, Navigation.ROUTES.verordnungEdit.url,
          Navigation.ROUTES.verordnungDetail.url]
      }
    ]
      .filter(i => authorizationFilter.viewAllowed(i.url))

    return html`
      <isceco-horizontal-navigation .items="${items}">
      </isceco-horizontal-navigation>
    `
  }
}
customElements.define('eko-frontend-horizontal-navigation', HorizontalNavigation)
